module.exports = __webpack_public_path__ + "media/images/covers/Foundation-Open-Day-Mobile-c019104c2216efb2ddf4e1f9dd392339.png";